import { Table } from "@abel-technologies-as/components";
import { renderColumns } from "./Columns";
import { useState } from "react";
import { ConfirmaPayoutData } from "./ConfirmaPayoutTable.types";

export const ConfirmaPayoutTable = ({ payoutData }: { payoutData: ConfirmaPayoutData[] }) => {
	const [ids, setIds] = useState<Array<number | string>>([]);
	return (
		<Table
			includeActions={false}
			ids={ids}
			setIds={setIds}
			showFooter={false}
			checkboxSelection={false}
			rows={payoutData.map((data, index) => ({ id: index, ...data }))}
			columns={renderColumns()}
		/>
	);
};
